





















































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import _ from "lodash";

import {
  PossibleExpense,
  ExpenseEligibility,
  PredictedEligibility,
  ExpenseEligibilityGroup
} from "@/shared/types";

import Widget from "@/shared/components/Widget.vue";
import ExpenseRow from "@/shared/components/expenseV2/ExpenseRow.vue";
import { formatCurrency } from "@/shared/currency.js";
import { useExpenseV2Store } from "@/employee/store/expenseV2";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    Widget,
    ExpenseRow
  }
})
export default class ExpensesList extends Vue {
  expenseStore = useExpenseV2Store();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  expenses: PossibleExpense[];

  @Prop()
  total: number;

  @Prop()
  loading: boolean;
  formatCurrency = formatCurrency;
  ExpenseEligibility = ExpenseEligibility;
  isChecked = false;
  ids = [];
  selectedExpenseEligibility = ExpenseEligibility.Eligible;
  processingEligibility = null;

  get selectedExpensesCount () {
    return this.ids.length;
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }

  get isSubmitDisabled (): boolean {
    if (this.portalFunctionalityDisabled) {
      return true;
    }

    return this.selectedExpensesCount === 0;
  }

  resetTransactions (): void {
    this.isChecked = false;
    this.ids = [];
    this.processingEligibility = ExpenseEligibility.None;
  }

  @Watch("expenses")
  resetSelectAll (): void {
    _.forEach(this.expenses, x => {
      if (this.ids.indexOf(x.transactionId) === -1) {
        this.isChecked = false;
      }
    });

    if (this.expenseStore.transactionRemoveCompleted) {
      this.resetTransactions();
    }
  }

  get eligibleSelected (): boolean {
    return this.selectedExpenseEligibility === ExpenseEligibility.Eligible;
  }

  get ineligibleSelected (): boolean {
    return this.selectedExpenseEligibility === ExpenseEligibility.Ineligible;
  }

  isSelected (id: any): boolean {
    this.isChecked = this.ids.length === 10;
    return this.ids.indexOf(id) > -1;
  }

  toggleSelectAll (isChecked: boolean): void {
    if (isChecked) {
      this.ids = this.expenses.map(x => x.transactionId);
      return;
    }

    this.ids = [];
  }

  updateId (id: string): void {
    const index = this.ids.indexOf(id);
    if (index > -1) {
      this.ids.splice(index, 1);
      return;
    }

    this.ids.push(id);
  }

  saveSelections (eligibilityStatus): void {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    if (this.selectedExpensesCount === 0) {
      return;
    }

    const transactionsToUpdate = this.ids.map(i => {
      if (this.expenses.some(x => x.transactionId === i && x.eligibilityStatus !== eligibilityStatus)) {
        return {
          transactionId: i,
          eligibilityStatus
        };
      }
    }).filter(x => x !== undefined);

    if (transactionsToUpdate.length === 0) return;
    this.expenseStore.setEligibility({ expenseStatusList: transactionsToUpdate } as any)
        .then(() => {
          this.ids = [];
        });
    this.selectedExpenseEligibility = ExpenseEligibility.Eligible;
    this.processingEligibility = eligibilityStatus;
  }

  getTotal () {
    return this.total !== undefined ? formatCurrency(this.total) : "$0.00";
  }

  // this is a reverse mapping of ExpenseService.Service.Mapper::PredictedEligibleStatusFromEligibilityGroup
  mapExpenseType (predictedEligibility: PredictedEligibility) {
    switch (predictedEligibility) {
      case PredictedEligibility.LikelyEligible:
        return ExpenseEligibilityGroup.LikelyEligible;
      case PredictedEligibility.MayBeEligibleLow:
      case PredictedEligibility.MayBeEligibleHigh:
        return ExpenseEligibilityGroup.PotentialEligible;
      case PredictedEligibility.UnlikelyEligible:
        return ExpenseEligibilityGroup.UnlikelyEligible;
      default:
        return ExpenseEligibilityGroup.None;
    }
  }
}
